// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-modal {
  --width: 290px;
  --height: 400px;
  --border-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/admin/tasks/modals/create-timesheet/create-timesheet.page.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,eAAA;EACA,oBAAA;AACJ","sourcesContent":["ion-modal {\n    --width: 290px;\n    --height: 400px;\n    --border-radius: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
